/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetDriftRequest extends models.CommonCostRequest {
    getFixupPrototypeFunction() { return BudgetDriftRequest.fixupPrototype; }

    static newInstance(model: Partial<BudgetDriftRequest>): BudgetDriftRequest {
        let obj = Object.assign(new BudgetDriftRequest(), model);
        BudgetDriftRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetDriftRequest>): BudgetDriftRequest {
        if (!model) return null;
        return BudgetDriftRequest.newInstance(<BudgetDriftRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetDriftRequest) {
        if (!obj) return;

        models.BudgetDriftRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetDriftRequest): boolean {
        if (models.CommonCostRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BudgetDriftRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of budget
     */
    configuration_type: models.BudgetType;

}
